import type { CSSProperties } from 'react';
import type { IconComponent } from '@backstage/core-plugin-api';

const iconSizes = {
  small: 20,
  medium: 24,
  large: 35,
};

export const KargoIcon: IconComponent = ({ fontSize = 'medium' }) => {
  const size = fontSize === 'inherit' ? '1.5em' : iconSizes[fontSize];
  const style: CSSProperties = {
    display: 'inline-block',
    width: size,
    height: size,
    flexShrink: 0,
    backgroundColor: 'currentColor',
    WebkitMask: "url('/kargo.svg') center / contain no-repeat",
    mask: "url('/kargo.svg') center / contain no-repeat",
  };

  return <span aria-hidden="true" style={style} />;
};
